module.exports = __webpack_public_path__ + "static/media/photo97.5d51edfa.jpg";